module.exports = new __parcel__URL__("ProductCardImage.40570c61.png").toString();